"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[263,664],{

/***/ 5664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ButtonGroup": function() { return /* reexport */ ButtonGroup; },
  "IconButton": function() { return /* reexport */ button_IconButton; },
  "default": function() { return /* reexport */ Button/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/base/button/ButtonGroup.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ButtonGroup = function(_param) {
    var children = _param.children, className = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: (0,functions.classnames)('button-group', className)
    }, rest, {
        children: children
    })));
};


// EXTERNAL MODULE: ./components/base/button/Button.tsx
var Button = __webpack_require__(5500);
;// CONCATENATED MODULE: ./components/base/button/IconButton.tsx



function IconButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IconButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IconButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function IconButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = IconButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function IconButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconButton = function(_param, ref) {
    var children = _param.children, rest = IconButton_objectWithoutProperties(_param, [
        "children"
    ]);
    if (/*#__PURE__*/ react.isValidElement(children)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, IconButton_objectSpread({
            className: "button--icon",
            iconBefore: children,
            ref: ref
        }, rest)));
    }
    return null;
};
/* harmony default export */ var button_IconButton = (/*#__PURE__*/react.forwardRef(IconButton));

;// CONCATENATED MODULE: ./components/base/button/index.tsx





/***/ }),

/***/ 2263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ section_Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
// EXTERNAL MODULE: ./components/base/button/index.tsx + 2 modules
var base_button = __webpack_require__(5664);
;// CONCATENATED MODULE: ./components/base/section/Section.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Section = function(props) {
    var anchor = props.anchor, children = props.children, container = props.container, description = props.description, title = props.title, rest = _objectWithoutProperties(props, [
        "anchor",
        "children",
        "container",
        "description",
        "title"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", _objectSpread({}, rest, {
        className: (0,functions.classnames)('section', rest.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, _objectSpread({}, container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: "section-header",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "section-header-title",
                            dangerouslySetInnerHTML: {
                                __html: String(title)
                            }
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "section-header-description",
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }),
                        anchor && /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button["default"], {
                            shape: "pill",
                            size: "large",
                            anchor: anchor
                        })
                    ]
                })
            })),
            children
        ]
    })));
};
/* harmony default export */ var section_Section = (Section);

;// CONCATENATED MODULE: ./components/base/section/index.tsx



/***/ })

}]);